import React, { Fragment } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import compos from "./components/compos";

const App = () => {
  return (
    <Fragment>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<compos.Home />} />
          <Route path="/about" element={<compos.About />} />
          <Route path="/contact" element={<compos.Contact />} />
          <Route path="/project" element={<compos.ProjectDetails />} />
        </Routes>
      </BrowserRouter>
    </Fragment>
  );
};

export default App;
